<template>
  <div
    class="delete-button"
    :class="{ active: isActive }"
    @click="isActive = true"
  >
    <div class="delete-button__inner">
      <button class="delete-button__action">Delete</button>
      <div class="delete-button-sets">
        <button class="delete-button-set" @click.stop="isActive = false">
          Cancel
        </button>
        <button class="delete-button-set" @click="emit('onConfirm')">
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const isActive = ref(null)

const emit = defineEmits(['onConfirm'])
</script>
